export default function getFormattedHoursAndMinutes(milliseconds) {
  const ONE_MINUTE_IN_MILLISECONDS = 60 * 1000;
  const ONE_HOUR_IN_MILLISECONDS = ONE_MINUTE_IN_MILLISECONDS * 60;
  const hours = `${Math.floor(milliseconds / ONE_HOUR_IN_MILLISECONDS)}`.padStart(2, '0');
  const minutes = `${Math.floor((milliseconds % ONE_HOUR_IN_MILLISECONDS) / ONE_MINUTE_IN_MILLISECONDS)}`.padStart(2, '0');

  return { hours, minutes };
}
